import { defineComponent, h } from 'vue';
import { Color } from '../../props.js';

const CTableRow = defineComponent({
    name: 'CTableRow',
    props: {
        /**
         * Highlight a table row or cell..
         */
        active: Boolean,
        /**
         * Set the vertical aligment.
         *
         * @values 'bottom', 'middle', 'top'
         */
        align: {
            type: String,
            validator: (value) => {
                return ['bottom', 'middle', 'top'].includes(value);
            },
        },
        /**
         * Sets the color context of the component to one of CoreUI’s themed colors.
         *
         * @values  'primary', 'secondary', 'success', 'danger', 'warning', 'info', 'dark', 'light', string
         */
        color: Color,
    },
    setup(props, { slots }) {
        return () => h('tr', {
            class: [
                {
                    [`align-${props.align}`]: props.align,
                    'table-active': props.active,
                    [`table-${props.color}`]: props.color,
                },
            ],
        }, slots.default && slots.default());
    },
});

export { CTableRow };
//# sourceMappingURL=CTableRow.js.map
